import React, { useContext, useState } from "react";
import MediumButton from "../../components/core/MediumButton";
import { FirebaseContext } from "../../contexts";
import CircularLoader from "../../components/core/CircularLoader";
import Loader from "../../components/core/Loader";
import { useTutoringUser } from "../../hooks";
import chevronRight from "../../assets/svgs/ChevronRight.svg";
import StudentDetailModal from "./StudentDetailModal";

const env = process.env.REACT_APP_ENV;
const isTest = env === "test";
const SUT_LEARNING_SPACE_URL = `https://${isTest ? "test-" : ""}learning-portal.stepuptutoring.org`;
// const LEARNING_PORTAL_GUIDE_URL =
//   "https://stepuptutoringhelp.zendesk.com/hc/en-us/articles/26497297343892-Learning-Portal-Tech-Guide";

export default function StudentRow(props) {
  const [studentDetail, setStudentDetail] = useState(false);
  const [messagesLoading, setMessagesLoading] = useState(false);

  const { student, handleOpen } = props;
  const { user } = useTutoringUser();
  // const calendarLink = https://www.google.com/calendar/render?action=TEMPLATE&text=Step%20Up%20Tutoring%20session%20with%20${encodeURIComponent(student.First_Name)}%20${encodeURIComponent(student.Last_Name)}&dates=20220101T010000Z/20220101T020000Z&details=${encodeURIComponent(MEETING_BASE_URL)}/${student.meetingId}
  const { services } = useContext(FirebaseContext);
  const [learningSpaceUrlLoading, setLearningSpaceUrlLoading] = useState(false);

  const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";

  function openLearningSpaceForStudent(studentId) {
    setLearningSpaceUrlLoading(true);
    services
      .launchLearningPortalForStudent({ studentId })
      .then((res) => {
        // Open the learning space replacing current location
        const information = student?.information;
        const eedi = information?.["Eedi login"] || student?.eedi;
        const grade = information?.["Grade Level"] || student?.grade;
        const url = `${SUT_LEARNING_SPACE_URL}/login?url=${encodeURIComponent(res.data)}&name=${encodeURIComponent(
          `${capitalize(student.First_Name)} and ${capitalize(user.First_Name)}`
        )}&eedi=${encodeURIComponent(eedi)}&subjects=${encodeURIComponent(
          student.Subject_s_?.join(",")
        )}&grade=${grade}&tutorId=${user.Tutor_ID}&studentId=${student.Student_ID}`;
        window.open(url, "_blank").focus();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLearningSpaceUrlLoading(false);
      });
  }
  return (
    <>
      <div className="md:border border-0 md:border-l-0 md:border-r-0 flex md:items-center items-start md:px-4 md:py-5 px-0 py-3 md:flex-row flex-col md:gap-0 gap-3 flex-wrap">
        <div className="flex flex-col text-lg text-titleColor">
          <div
            className="font-semibold text-[20px] tracking-[0.1px] cursor-pointer hover:bg-[#F8FAFC] transition-colors duration-200"
            onClick={() => {
              setStudentDetail(true);
            }}>
            {`${student.First_Name} ${student.Last_Name}`}
          </div>
          {student?.lastSession > 10 && (
            <span className="text-[10px] font-medium leading-4 tracking-[0.05px] text-[#B3261E] mt-1">
              No session in {student.lastSession} days
            </span>
          )}
        </div>

        <div className="flex flex-1 items-center justify-between w-full">
          <div className="flex flex-col lg:table-cell whitespace-nowrap flex-1 text-sm text-gray-500">
            <div className="flex md:flex-row text-base md:gap-3 gap-1 lg:px-10 px-0 flex-col ">
              {student?.Last_Message && (
                <div className="text-sm truncate md:max-w-[300px] max-w-[130px]">
                  <span className="text-titleColor">{`${student.Last_Message_By}`}: </span>
                  <span className="text-[#6B7280] md:inline hidden">{`${student.Last_Message}`}</span>
                </div>
              )}

              <span
                onClick={() => {
                  setMessagesLoading(true);
                  handleOpen(student.id).finally(() => {
                    setMessagesLoading(false);
                  });
                }}
                className="text-blueGreen text-sm hover:cursor-pointer font-semibold flex items-center gap-2 group">
                {messagesLoading ? (
                  <div className="flex items-center gap-2">
                    <Loader size="small" />
                  </div>
                ) : (
                  <>
                    View Messages
                    <img src={chevronRight} alt="Chevron-Right" />
                  </>
                )}
              </span>
            </div>
            {/* <div className="text-xs mt-1 text-gray-500 underline hover:cursor-pointer">
            <ExternalLink href={LEARNING_PORTAL_GUIDE_URL}>
              <span>Open Learning Portal Guide</span>
            </ExternalLink>
          </div> */}
          </div>
          <div className="flex flex-col whitespace-nowrap text-sm text-gray-500">
            <MediumButton
              click={() => openLearningSpaceForStudent(student.Student_ID)}
              type="solid"
              loading={learningSpaceUrlLoading}
              CircularLoader={CircularLoader}
              className="w-full">
              Join Meeting
            </MediumButton>
          </div>
        </div>
      </div>
      <StudentDetailModal
        isOpen={studentDetail}
        handleClose={() => setStudentDetail(false)}
        studentData={student}
        openLearningSpaceForStudent={() => openLearningSpaceForStudent(student.Student_ID)}
      />
    </>
  );
}
